import { Component, OnInit, Inject, PLATFORM_ID, AfterViewInit } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cookies-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './cookies-banner.component.html',
  styleUrl: './cookies-banner.component.scss'
})
export class CookiesBannerComponent implements OnInit, AfterViewInit {
  private readonly COOKIE_CONSENT_KEY = 'cookie_consent_accepted';
  isVisible = false;
  private isBrowser: boolean;
  
  constructor(
    public translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    // Don't check here for SSR - wait for AfterViewInit
  }

  ngAfterViewInit(): void {
    // Check consent after view is initialized (browser-only)
    if (this.isBrowser) {
      // Small delay to ensure localStorage is available
      setTimeout(() => {
        this.checkCookieConsent();
      }, 100);
    }
  }

  private checkCookieConsent(): void {
    try {
      if (typeof window === 'undefined' || !window.localStorage) {
        console.log('[CookiesBanner] localStorage not available');
        return;
      }
      
      const consent = localStorage.getItem(this.COOKIE_CONSENT_KEY);
      console.log('[CookiesBanner] Consent value:', consent);
      
      if (!consent) {
        this.isVisible = true;
        console.log('[CookiesBanner] Showing banner');
      } else {
        console.log('[CookiesBanner] Banner already handled');
      }
    } catch (error) {
      console.error('[CookiesBanner] Error checking consent:', error);
    }
  }

  acceptCookies(): void {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return;
      
      localStorage.setItem(this.COOKIE_CONSENT_KEY, 'true');
      this.isVisible = false;
      console.log('[CookiesBanner] Cookies accepted');
    } catch (error) {
      console.error('[CookiesBanner] Error accepting cookies:', error);
    }
  }

  declineCookies(): void {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return;
      
      localStorage.setItem(this.COOKIE_CONSENT_KEY, 'false');
      this.isVisible = false;
      console.log('[CookiesBanner] Cookies declined');
    } catch (error) {
      console.error('[CookiesBanner] Error declining cookies:', error);
    }
  }

  get isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }

  // Open manage cookies dialog/page
  openManageCookies(): void {
    // Navigate to privacy policy or open a manage cookies dialog
    // For now, just close the banner - you can implement detailed cookie management later
    console.log('[CookiesBanner] Manage cookies clicked');
    // Optionally keep the banner open and show more options
    // Or navigate to: this.router.navigate(['/privacy-policy']);
  }

  // Debug method - call this from browser console
  resetConsent(): void {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return;
      localStorage.removeItem(this.COOKIE_CONSENT_KEY);
      this.isVisible = true;
      console.log('[CookiesBanner] Consent reset - banner should show');
    } catch (error) {
      console.error('[CookiesBanner] Error resetting consent:', error);
    }
  }
}
